import React from 'react';
import PropTypes from 'prop-types';
import {browserHistory} from 'react-router';
import {PartnershipOverviewComponent} from '../../../common/CMS/components/PartnershipOverviewComponent';
import {requestHelpers} from "../../../../helpers";
import Pagination from "../../../common/elements/Pagination";
import {PaginationHelpers as Page} from '../../../../helpers';
import {PartnershipOverviewPlaceholderComponent} from "../../../common/placeholders/PartnershipOverviewPlaceholderComponent";
import Header from "../../../../layouts/Header";
import {Heading, Text} from "../../../common/CMS/elements";
import ThemePageBanner from "../../../dashboardNew/components/ThemePageBanner";

class CorporateOverviewPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            companies: null,
            currentPage: 1,
            totalPages: null,
            initialLoad: true,
            isLoading: true
        };
    }

    componentWillMount() {
        let page = this.props.location.query.page;
        this.getNextCorporate(page ? page : 1);
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.props.location.query.page !== nextProps.location.query.page && !nextState.initialLoad) {
            this.getNextCorporate(nextProps.location.query.page, true);
        }
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    getNextCorporate(page, top = false) {
        this.setState({isLoading: true});
        this.makeRequest(page);
        this.state.companies && this.state.initialLoad && this.setState({initialLoad: false});
        browserHistory.push(`${this.props.location.pathname}?page=${page}${top ? "#topoflist" : ''}`);
    }

    //Add these queries to request URl to sort by name ascending: orderby=title&order=asc
    makeRequest = (page) => {
        requestHelpers
            .getWordPressData(`https://blog.intouchnetworks.com/wp-json/wp/v2/pages/?categories=17&per_page=9&page=${page}`)
            .then(response => {
                this.setState({
                    companies: response.data,
                    totalItems: response.headers.totalItems,
                    totalPages: response.headers.totalPages,
                    currentPage: page,
                    isLoading: false
                });
            });
    };


    render() {
        let currentPage = Page.setCurrentPage(this.props.location.query.page, this.state.totalPages);
        let pagination_details = Page.getCurrentPage(currentPage, this.state.totalPages);
        let pageNumbers = Page.getPageNumbers(pagination_details);
        //Hacky way of displaying (via mapping through) 9 placeholder 03_objects
        let placeholderArray = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        return (
            <div className="container-fluid partners-page theme-page-content-wrapper">
                <ThemePageBanner image='/images/how-background.jpg' heading='Consultancy'/>
                <div className='container'>
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            <p className="body-copy">Are you currently working with an organisation that is interested
                                in utilising the knowledge and expertise of a consultant? Browse the various consultants
                                who are actively on the In Touch network and reach out to them today to start making use
                                of their services.</p>
                        </div>
                        {this.state.companies && !this.state.isLoading && (
                            this.state.companies.map((company, i) => {
                                return (
                                    <PartnershipOverviewComponent
                                        description={company.description}
                                        header={company.title}
                                        primaryColor={company.primaryColor}
                                        buttonTextColor={company.primaryTextColor}
                                        secondaryColor={company.secondaryColor}
                                        logo={company.logo}
                                        button={company.button}
                                        link={`${this.props.location.pathname}/${company.link}`}
                                        key={i}
                                    />
                                )
                            })
                        )}
                        {this.state.isLoading && (
                            placeholderArray.map((company, i) => {
                                return <PartnershipOverviewPlaceholderComponent key={i}/>
                            })
                        )}
                        <Pagination
                            currentPage={this.state.currentPage}
                            network={null}
                            pagination={pagination_details}
                            pageNumbers={pageNumbers}
                            totalPages={this.state.totalPages}
                            onPaginationClick={(currentPage) => this.getNextCorporate(currentPage, true)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default CorporateOverviewPage;

CorporateOverviewPage.propTypes = {
    companies: PropTypes.array,
    pagenation: PropTypes.object,

};



// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/CorporateOverviewPage.js